/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdPickerProps } from './type';

export const pickerDefaultProps: TdPickerProps = {
  cancelBtn: true,
  columns: [],
  confirmBtn: true,
  swipeDuration: 300,
  title: '',
  visible: false,
};
